import Butter from "buttercms";

export function butterObject() {
  try {
    return Butter(process.env.REACT_APP_CMS_READ_KEY_PROD, process.env.REACT_APP_CMS_PREVIEW_MODE === "true");
  } catch (e) {
    console.error("Error initializing ButterCMS", e.message);
  }
}